const BACK_IN_STOCK_SELECTOR = '[data-back-in-stock-root]';

function getRoot(element) {
  return element?.closest(BACK_IN_STOCK_SELECTOR);
}

function getStrings() {
  return window.FoxTheme?.backInStockStrings || {};
}

function getConfig(root) {
  const strings = getStrings();

  return {
    apiKey: (root.dataset.klaviyoApiKey || '').trim(),
    variantId: root.dataset.variantId || '',
    successMessage: strings.successMessage || '',
    errorMessage: strings.errorMessage || '',
    configErrorMessage: strings.configErrorMessage || '',
    submittingMessage: strings.submittingMessage || '',
  };
}

function decodeHtmlEntities(value) {
  if (!value) return value;

  let decoded = value;
  const textarea = document.createElement('textarea');

  for (let i = 0; i < 2; i += 1) {
    textarea.innerHTML = decoded;
    const next = textarea.value;

    if (next === decoded) break;
    decoded = next;
  }

  return decoded;
}

function showMessage(root, message, type) {
  const messageEl = root.querySelector('[data-back-in-stock-message]');
  if (!messageEl || !message) return;

  messageEl.hidden = false;
  messageEl.classList.remove('hidden');
  messageEl.textContent = decodeHtmlEntities(message);
  messageEl.classList.remove('alert--success', 'alert--error');
  messageEl.classList.add(type === 'success' ? 'alert--success' : 'alert--error');
  messageEl.setAttribute('role', type === 'success' ? 'status' : 'alert');
  messageEl.focus();
}

function setSubmitting(root, isSubmitting) {
  const submitButton = root.querySelector('[data-back-in-stock-submit]');
  const submitButtonText = submitButton?.querySelector('.btn__text');
  if (!submitButton || !submitButtonText) return;

  if (!submitButton.dataset.defaultLabel) {
    submitButton.dataset.defaultLabel = submitButtonText.textContent;
  }

  submitButton.disabled = isSubmitting;
  submitButtonText.textContent = isSubmitting
    ? getStrings().submittingMessage
    : submitButton.dataset.defaultLabel;
}

async function submitBackInStock(root) {
  const config = getConfig(root);
  const emailInput = root.querySelector('[data-back-in-stock-email]');
  const email = emailInput?.value.trim();

  if (!config.apiKey) {
    showMessage(root, config.configErrorMessage, 'error');
    return;
  }

  if (!config.variantId) {
    showMessage(root, config.errorMessage, 'error');
    return;
  }

  if (!email) {
    showMessage(root, config.errorMessage, 'error');
    return;
  }

  setSubmitting(root, true);

  try {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${config.variantId}`,
            },
          },
        },
      },
    };

    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(config.apiKey)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Revision: '2026-04-15',
        },
        body: JSON.stringify(payload),
        cache: 'no-store',
      }
    );

    if (response.ok) {
      showMessage(root, config.successMessage, 'success');
      if (emailInput) emailInput.value = '';
      return;
    }

    let errorMessage = config.errorMessage;

    try {
      const errorData = await response.json();
      const apiError = errorData.errors?.[0];

      if (apiError?.detail) {
        errorMessage = apiError.detail;
      }
    } catch (parseError) {
      // Keep default error message when response body is not JSON.
    }

    showMessage(root, errorMessage, 'error');
  } catch (error) {
    showMessage(root, config.errorMessage, 'error');
  } finally {
    setSubmitting(root, false);
  }
}

document.addEventListener('click', (event) => {
  const submitButton = event.target.closest('[data-back-in-stock-submit]');
  if (!submitButton) return;

  const root = getRoot(submitButton);
  if (!root) return;

  event.preventDefault();
  event.stopPropagation();
  submitBackInStock(root);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter') return;

  const emailInput = event.target.closest('[data-back-in-stock-email]');
  if (!emailInput) return;

  const root = getRoot(emailInput);
  if (!root) return;

  event.preventDefault();
  submitBackInStock(root);
});
